import { ImmutableMap } from "@suse-o11y/immutable-map";
import { type Monitor, Signal } from "@suse-o11y/signal";

/**
 * Manages a persistent storage state using an internal map of string keys to {@link Signal}-wrapped string values.
 * Provides methods to reactively get, set, remove, and clear items in the storage.
 */
export class PersistentStorageState {
	private readonly state = Signal(ImmutableMap.empty<string, undefined | Signal<string>>());

	public getItem(monitor: Monitor, key: string): undefined | string {
		return this.state.read(monitor).get(key)?.read(monitor);
	}

	public setItem(key: string, value: string): void {
		this.state.write((state) => {
			const current = state.get(key);

			// the item was not existing
			if (current == null) {
				return state.set(key, Signal(value));
			}

			// update existing item
			current.write(value);

			// without updating the map
			return state;
		});
	}

	public removeItem(key: string): void {
		// assign `undefined` when removing so that subscribers get notified
		this.state.write((state) => state.set(key, undefined));
	}

	public clear(): void {
		this.state.write((state) => state.clear());
	}
}
